module.exports = __webpack_public_path__ + "static/media/tubo-conduit-blogv2.6d870623.png";